module.exports = __webpack_public_path__ + "media/images/flags/1x1/kos-e36a716c53c42e33024ee6a5328fafd4.svg";